import { IonButton, IonIcon, useIonModal } from '@ionic/react';
import { QRWebModal } from 'components/QRWebModal';
import { scanOutline } from 'ionicons/icons';

const ScanButton: React.FC<
  {
    authState?: any;
    onScanFinished?: (data: string) => void;
    icon: any;
  } & any
> = ({
  authState,
  onScanFinished,
  icon,
  children,
  ...buttonProps
}) => {

  const handleScan = async (data:any) => {
    onScanFinished(data);
    dismissWebModal();
  };

  const handleError = (err:any) => {
    console.error(err);
  };

  const [presentWebModal, dismissWebModal] = useIonModal(QRWebModal, {
    dismiss: () => dismissWebModal(),
    scan: handleScan,
    error: handleError,
  });

  return (
    <>
      <IonButton
        onClick={()=>presentWebModal()}
        {...buttonProps}>
        {children || <IonIcon
          icon={icon || scanOutline}
          size="large" />}
      </IonButton>
    </>
  );
};

export default ScanButton;
